import React, { MouseEventHandler } from 'react';
import { TableCell } from '@material-ui/core';

type StackCellProps = {
  container: CellSizeContainer;
  className: string;
  style?: object;
  width: number;
  top: number;
  onClick?: ()=>void;
  onDoubleClick?: ()=>void;
};

export class CellSizeContainer {
  private ptr: number = 0;

  constructor(start: number = 0){
    this.ptr = start;
  }

  Add(add: number){
    this.ptr += add;
  }

  get Current(): number {
    return this.ptr;
  }
}
  
const StackCell: React.FC<StackCellProps> = (props) => {
  const pos = props.container.Current;
  props.container.Add(props.width);
  const top = props.top >= 0 ? {top: props.top} : null;
  const style = {...props.style, ...top, left: `${pos}px`, minWidth: `${props.width}px`, width: `${props.width}px`};

  return (
    <TableCell className={props.className} style={style} onClick={props.onClick} onDoubleClick={props.onDoubleClick}>
      {props.children}
    </TableCell>
  );
}
  
export default StackCell;